import React from 'react';
import { Typography, Card, Row, Col } from 'antd';
import { useNavigate } from 'react-router-dom';
import { ExperimentOutlined, ShareAltOutlined, PartitionOutlined, ClusterOutlined, NodeIndexOutlined } from '@ant-design/icons';


const { Title, Paragraph } = Typography;

export default function MolecularInteractionPage() {
  const navigate = useNavigate();

  const analysisModules = [
    {
      key: 'rnahybrid',
      title: 'RNAhybrid miRNA靶标预测',
      description: 'miRNA与mRNA靶标结合位点预测分析，支持多种物种的3\'UTR数据库',
      icon: <ExperimentOutlined style={{ fontSize: '48px', color: '#1890ff' }} />,
      features: [
        'miRNA-mRNA结合预测',
        '多物种支持',
        '结合位点可视化',
        '能量评分'
      ],
      path: '/interaction/rnahybrid'
    },
    {
      key: 'prodigy',
      title: 'PRODIGY 蛋白质-蛋白质互作',
      description: '基于蛋白质复合物3D结构预测蛋白质-蛋白质结合亲和力',
      icon: <ShareAltOutlined style={{ fontSize: '48px', color: '#52c41a' }} />,
      features: [
        '结合亲和力预测',
        '3D结构可视化',
        '接触分析',
        '链选择高亮'
      ],
      path: '/interaction/prodigy'
    },
    // ZDOCK - 版权限制，已禁用，内部使用时取消注释
    // {
    //   key: 'zdock',
    //   title: 'ZDOCK 分子对接',
    //   description: '高效的蛋白质-蛋白质对接程序，支持异步任务处理，实时查看进度与结果',
    //   icon: <PartitionOutlined style={{ fontSize: '48px', color: '#fa8c16' }} />,
    //   features: [
    //     '蛋白质对接',
    //     '异步处理',
    //     '任务管理',
    //     '3D结构查看'
    //   ],
    //   path: '/interaction/zdock'
    // },
    // MEGADOCK - 版权限制，已禁用，内部使用时取消注释
    // {
    //   key: 'megadock',
    //   title: 'MEGADOCK 蛋白质对接',
    //   description: 'MEGADOCK高性能蛋白质对接工具，支持PPI评分分析和异步任务处理',
    //   icon: <ClusterOutlined style={{ fontSize: '48px', color: '#722ed1' }} />,
    //   features: [
    //     '高性能蛋白质对接',
    //     'PPI评分分析',
    //     '异步任务处理',
    //     '结果可视化'
    //   ],
    //   path: '/interaction/megadock'
    // },
    {
      key: 'equidock',
      title: 'EquiDock 蛋白质对接',
      description: '基于深度学习的蛋白质对接工具，自动生成复合物结构并处理链名冲突',
      icon: <NodeIndexOutlined style={{ fontSize: '48px', color: '#eb2f96' }} />,
      features: [
        '深度学习对接',
        '复合物结构生成',
        '自动链名处理',
        '异步任务管理'
      ],
      path: '/interaction/equidock'
    }
  ];

  return (
      <div style={{ maxWidth: 1200, margin: '0 auto', padding: '24px' }}>
        <div style={{ textAlign: 'center', marginBottom: 48 }}>
          <Title level={2}>分子互作分析</Title>
          <Paragraph style={{ fontSize: '16px', color: '#666' }}>
            提供RNA-RNA互作、蛋白质-蛋白质互作、分子对接等多种分析功能
          </Paragraph>
        </div>

        <Row gutter={[24, 24]}>
          {analysisModules.map((module) => (
            <Col xs={24} sm={12} md={6} key={module.key}>
              <Card
                hoverable
                style={{ 
                  height: '100%',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease'
                }}
                bodyStyle={{ padding: '32px 24px' }}
                onClick={() => navigate(module.path)}
              >
                <div style={{ textAlign: 'center', marginBottom: 24 }}>
                  {module.icon}
                </div>
                
                <Title level={4} style={{ textAlign: 'center', marginBottom: 16 }}>
                  {module.title}
                </Title>
                
                <Paragraph style={{ 
                  textAlign: 'center', 
                  color: '#666',
                  marginBottom: 24,
                  minHeight: '48px'
                }}>
                  {module.description}
                </Paragraph>
                
                <div>
                  <Title level={5} style={{ marginBottom: 12 }}>主要功能：</Title>
                  <ul style={{ paddingLeft: 20, margin: 0 }}>
                    {module.features.map((feature, index) => (
                      <li key={index} style={{ marginBottom: 4, color: '#666' }}>
                        {feature}
                      </li>
                    ))}
                  </ul>
                </div>
              </Card>
            </Col>
          ))}
        </Row>
      </div>

  );
}